import React, { useState, useEffect, Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { getProfile } from "../../helpers/api_rombo_helper";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "../../components/Common/withRouter";
import Breadcrumb from "../../components/Common/Breadcrumb";
import i18n from "../../i18n";
import { orgId } from "../../constants/utils";
import defaultImage from "../../assets/images/default-profile.png";

const UserProfile = (props) => {
  document.title = `${i18n.t("Profile")} - ${orgId}`;

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [full_name, setName] = useState("");
  const [sub, setSub] = useState("");
  const [status, setStatus] = useState("");
  const [picture, setPicture] = useState("");

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    onGetProfile()
  }, [dispatch, loading]);

  const onGetProfile = () => {
    getProfile(token)
      .then((response) => {
        setName(response.full_name);
        setEmail(response.email);
        setSub(response.id);
        setStatus(response.status);
        setPicture(response.picture || defaultImage);
      })
      .catch((error) => {
        console.error("Error - getProfile - ", error);
      });
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: full_name || '',
      sub: sub || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {

    }
  });

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="" breadcrumbItem={i18n.t("Profile")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={picture}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center mx-1">
                      <div className="text-muted">
                        <h5>{full_name}</h5>
                        <p className="mb-1">Email: {email}</p>
                        <p className="mb-0">ID: {sub}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default withRouter(UserProfile);
